// @ts-nocheck
import { resultTypeToAffix } from "~/util/search";
import { Scene, CONFIG, store } from "~/route/globals";
import HistorySuggestItem from "~/es6/history.suggest.item";
import { search } from "~/util/providers/search";
import { ROUTE_CONST } from "~/route/const";
import { getPOI } from "~/route/utils";
import { node, icon } from "~/util/dom";
import { _ } from "~/i18n";

const TIMEOUT = 300;

/**
 * Obal pro:
 * - suggest a mapclick
 */
export default class SuggestMapClick {
	_contElem: HTMLElement;

	_zeroElem: HTMLElement;

	constructor(element: HTMLElement, callback: () => void) {
		this._el = element;
		this._contElem = null;
		this._cb = callback;
		this._onFocus = null;
		this._onBlur = null;
		this._dom = {
			input: Mapy.Util.node("input", { type: "text" }),
		};
		this._toID = null;
		this._suggest = null;
		this._cursor = null;
		this._sugItems = null;
		this._prehitorikRemove = false;
		this._isEnterReq = false;
		this._zeroElem = null;

		this._build();

		window.addEventListener("routeDefaultState", this);
	}

	destroy() {
		window.removeEventListener("routeDefaultState", this);
		if (this._cursor) {
			Mapy.Cursor.remove(this._cursor);
			this._cursor = null;
		}
		this._suggest.destroy();
	}

	get input() {
		return this._dom.input;
	}

	set contElem(contElem: HTMLElement) {
		this._contElem = contElem;
	}

	set position(position: number) {
		this._position = position;
	}

	setEvents(onFocus, onBlur) {
		this._onFocus = onFocus;
		this._onBlur = onBlur;
	}

	setData(data) {
		let geometry = null;

		if (data.mark) {
			geometry = Scene.coordsToString([Scene.coordsFromWGS84(data.mark.lon, data.mark.lat)]);
		} else if (data.coords) {
			geometry = Scene.coordsToString([data.coords]);
		}

		const signalData = {
			id: data.id,
			source: data.source,
			geometry,
			title: data.title,
			desc: data.secondRow || data.multiTitle ? data.multiTitle.slice(1).join(", ") : data.title,
			typeId: data.poiTypeId || data.typeId || 0,
			from: "history",
		};

		// pokud nahodou prijde source a id a je typ point, sereme na ne
		if (data.dataType === "point") {
			const coords = Scene.stringToCoords(geometry)[0];

			signalData.source = "coor";
			signalData.id = coords.toWGS84().join(",");
			signalData.title = coords.toWGS84(2).join(",");
		}

		this._sendSignal(signalData);
	}

	handleEvent(event) {
		// pri tomto eventu a mame zobrazeny input ho vymaze
		if (event.type === "routeDefaultState") {
			this._sugItems = null;
			this._dom.input.blur();
			this._dom.input.value = "";
		}
	}

	mapClick(event, target) {
		const coords = Scene.coordsFromEvent(event);

		Mapy.CML.state = {
			route: {
				loading: true,
			},
		};
		this._dom.input.blur();

		if (target) { // pokud mame poiku
			let data = null;
			const onlyCoords = ["foto", "ffoto", "wcam"].indexOf(target.getSource()) > -1;

			let poi = {};

			if (onlyCoords) {
				poi = {
					id: coords.toWGS84().join(","),
					title: coords.toWGS84(2).reverse().join(", "),
					images: null,
					source: "coor",
					geometry: Scene.coordsToString([coords]),
					from: "mapClick",
				};
			} else {
				if (typeof target.getPOI === "function") {
					data = target.getPOI();
				} else {
					const dataCoords = target.getCoords().toWGS84();

					data = {
						x: dataCoords[0],
						y: dataCoords[1],
						title: target.getCoords().toWGS84(0).join(","),
						id: target.getPlainId(),
						source: target.getSource(),
					};
				}

				// kotrolujeme, zda uz souradnice mame z descriptionu a pokud ne, vezmeme z lookupu
				const dataCoords = data.x ? Scene.coordsFromWGS84(data.x, data.y) : Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);

				poi = {
					title: data.title,
					desc: data.address ? data.address.join(", ") : data.multiTitle && data.multiTitle[1] ? data.multiTitle[1] : "",
					geometry: Scene.coordsToString([dataCoords]),
					id: data.id,
					source: data.source,
					typeId: data.typeId,
					from: "mapClick",
				};
			}

			Mapy.CML.state = {
				route: {
					zoom: false,
					loading: false,
				},
			};

			// analytika - nove logovani sjednocene s appkou
			Mapy.Util.analyticsSearchSelection({
				query: "",
				// eslint-disable-next-line camelcase
				result_type: "location_pick",
				// eslint-disable-next-line camelcase
				search_purpose: "route_planner",
			}, onlyCoords ? poi : data);
			this._sendSignal(poi);
		} else {
			getPOI(coords).then(poi => {
				Mapy.CML.state = {
					route: {
						zoom: false,
						loading: false,
					},
				};

				// analytika - nove logovani sjednocene s appkou
				Mapy.Util.analyticsSearchSelection({
					query: "",
					// eslint-disable-next-line camelcase
					result_type: "location_pick",
					// eslint-disable-next-line camelcase
					search_purpose: "route_planner",
				}, poi);

				poi.from = "mapClick";
				this._sendSignal(poi);
			}, () => {});
		}
	}

	_build() {
		// do inputu je navaseny klik do mapy
		this._dom.input.addEventListener("focus", event => {
			this._inputFocus(event);
		});
		this._dom.input.addEventListener("blur", () => {
			this._inputBlur();
		});
		this._dom.input.addEventListener("keydown", event => {
			const value = this._dom.input.value.trim();

			switch (event.which) {
				case 9:
					if (value.length && !this._sugItems) {
						search(value).promise.then(data => {
							if (data && data.result.length) {
								const firstResult = data.result[0];
								const suggestData = Object.assign(firstResult, {
									name: firstResult.title,
									longitude: firstResult.mark.lon,
									latitude: firstResult.mark.lat,
								});

								this._setSuggestData(suggestData, 0);
							}
						}, () => {});
					}
					break;
				case 27:
					this._suggest.close();
					this._sugItems = null;
					break;
				default:
					break;
			}
		});
		// naseptavac
		this._suggest = new SMap.Suggest(this._dom.input, {
			factory: (data, pos) => {
				const item = new HistorySuggestItem(data, pos);

				item.historyDeleteCallback = () => {
					this._prehitorikRemove = true;
				};

				return item;
			},
			provider: new SMap.SuggestProvider({
				url: `${CONFIG.requestUrl}/suggest/`,
				poiaggUrl: `${CONFIG.requestUrl}/poiagg`,
				limit: 8,
			}),
			abTest: CONFIG.abTest ? CONFIG.abTest.flags : "",
		});
		this._suggest.addListener("suggest", suggestData => {
			this._isEnterReq = false;
			this._clearTO();
			this._setSuggestData(suggestData.data, suggestData.position, undefined, suggestData.prevPhrase);
		});
		this._suggest.addListener("enter", () => {
			if (this._dom.input.value) {
				if (this._zeroElem) {
					this._buildNoResults();

					return;
				}

				this._suggest.send();
				this._isEnterReq = true;
			}
		});
		this._suggest.getProvider().updateParams(paramsObj => {
			const state = store.getState();
			const { user } = state.user;
			const { longitude, latitude, zoom } = store.getState().map;

			paramsObj.lon = longitude;
			paramsObj.lat = latitude;
			paramsObj.zoom = zoom;
			paramsObj.lang = CONFIG.langPriority.join(",");
			paramsObj.personalize = user.state === "green" ? 1 : 0;
			paramsObj.pubtBoost = Mapy.CML.state.route.params.type === ROUTE_CONST.TYPE_PUBT ? 1 : 0;
			paramsObj.count = 8;

			if (Mapy.userLocation.position) {
				paramsObj.userLat = Mapy.userLocation.position.lat;
				paramsObj.userLon = Mapy.userLocation.position.lon;
				paramsObj.userAccuracy = Mapy.userLocation.position.accuracy;
			}
		});
		this._suggest.addListener("request", () => {
			this._destroyZeroSearch();
		});
		this._suggest.addListener("request-items", responseData => {
			this._sugItems = responseData;

			if (this._isEnterReq && this._sugItems && this._sugItems.length && !this._prehitorikRemove) {
				this._setSuggestData(this._sugItems[0], -1, this._sugItems.length, this._suggest.getPhrase());
				this._sugItems = null;
				this._inputBlur();
			} else if (this._suggest.getPhrase() !== "" && !(this._sugItems && this._sugItems.length)) {
				if (this._isEnterReq) {
					this._buildNoResults();
				} else {
					this._buildZeroSearch();
				}
			}

			this._isEnterReq = false;
		});
		this._dom.input.addEventListener("input", event => {
			const value = event.target.value.trim();

			if (value.length === 0) {
				this._destroyZeroSearch();
			}
		});
	}

	_destroyZeroSearch() {
		if (this._zeroElem) {
			this._zeroElem.remove();
			this._zeroElem = null;
		}
	}

	_buildZeroSearch() {
		this._destroyZeroSearch();

		const elem = node("div", { className: "suggest-zero-search" });
		const searchPart = node("div", { className: "suggest-zero-search__search" });
		const searchPartText = node("span", { className: "suggest-zero-search__searchText" });

		searchPartText.innerHTML = `${_("search")} <strong>${Mapy.Util.escapeHTML(this._suggest.getPhrase().trim())}</strong>`;
		searchPart.append(
			icon("mag-glass"),
			searchPartText,
		);
		searchPart.addEventListener("click", () => {
			this._buildNoResults();
		});
		searchPart.classList.add("visible");
		elem.append(searchPart);
		this._contElem.append(elem);
		this._zeroElem = elem;
	}

	_buildNoResults() {
		if (!this._zeroElem) {
			this._zeroElem = node("div", { className: "suggest-zero-search" });
			this._contElem.append(this._zeroElem);
		}

		const searchPart = node("div", { className: "suggest-zero-search__search" });
		const searchPartText = node("span", { className: "suggest-zero-search__searchText" });

		this._zeroElem.innerHTML = "";

		searchPart.append(searchPartText);
		searchPartText.innerHTML = _("route.suggest.noResults", { query: Mapy.Util.escapeHTML(this._suggest.getPhrase().trim()) });
		searchPart.addEventListener("click", () => {
			this._dom.input.value = "";
			this._destroyZeroSearch();
		});
		this._zeroElem.append(searchPart);
	}

	/**
	 * Nastaveni dat suggest -> item.
	 * Bud pri blur/vyber z naseptavace.
	 *
	 * @param   {Object}  data
	 */
	_setSuggestData(data, index = -1, totalCount = 1, phrase = "") {
		// analytika - nove logovani sjednocene s appkou
		Mapy.Util.analyticsSearchSelection({
			query: phrase.trim().toLowerCase(),
			// eslint-disable-next-line camelcase
			search_type: "suggestion",
			index: index < 0 ? 0 : index + 1,
			results: this._sugItems ? this._sugItems.slice(0, 10).map(item => `${item.source}_${item.id}${resultTypeToAffix(item.resultType, item.mmsource)}`) : [],
			// eslint-disable-next-line camelcase
			search_purpose: "route_planner",
			target: "route",
		}, data, data);
		// analytika
		Mapy.getComponent("logger").log("route-suggest", {
			q: this._dom.input.value.toLowerCase(),
			id: data.id,
			source: data.source,
			index,
			text: data.name,
			totalCount,
		});
		this._sugItems = null;
		Mapy.CML.state = {
			route: {
				zoom: true,
			},
		};

		this._sendSignal({
			id: data.id,
			source: data.source,
			geometry: Scene.coordsToString([Scene.coordsFromWGS84(data.longitude, data.latitude)]),
			title: data.title,
			desc: data.secondRow,
			typeId: data.poiTypeId || 0,
			from: "suggest",
			...data.mmid && data.mmtype !== "history"
				? {
					favoriteId: data.mmid,
					usertitle: data.title,
				}
				: {},
		});
	}

	_inputFocus() {
		this._el.classList.add("active");
		this._cursor = Mapy.Cursor.add({
			cursor: "crosshair",
			callback: this,
		});
		this._zeroElem && this._clearTO();

		if (typeof this._onFocus === "function") {
			this._onFocus();
		}
	}

	_inputBlur() {
		this._isEnterReq = false;
		this._el.classList.remove("active");

		if (this._cursor) {
			Mapy.Cursor.remove(this._cursor);
			this._cursor = null;
		}

		this._clearTO();
		this._toID = setTimeout(() => {
			const value = this._dom.input.value.trim();

			if (value.length && this._sugItems && !this._prehitorikRemove) {
				const firstItem = this._sugItems && this._sugItems.length ? this._sugItems[0] : null;

				if (firstItem) {
					this._setSuggestData(firstItem, -1, this._sugItems.length);
				}
			}

			this._destroyZeroSearch();

			this._sugItems = null;
			this._suggest.clearItems();
			this._prehitorikRemove = false;

			if (typeof this._onBlur === "function" && document.activeElement !== this._dom.input) {
				this._onBlur(true);
			}
		}, TIMEOUT);

		if (typeof this._onBlur === "function") {
			this._onBlur();
		}
	}

	_sendSignal(data) {
		if (typeof this._cb === "function") {
			this._cb(data);
		}
	}

	_clearTO() {
		if (this._toID) {
			clearTimeout(this._toID);
			this._toID = null;
		}
	}
}
